'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Actions = require('../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Utility = require('../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _MainStore = require('./MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DELIVERY = "Delivery";
var PICKUP = "PickUp";
var CURBSIDEPICKUP = "CurbsidePickUp";
var DINEIN = "DineIn";

var ScheduleScreenStore = _reflux2.default.createStore({
    listenables: [_Actions2.default],
    init: function init() {
        this._orderType = PICKUP;
        // Dine in
        this._sldata = '',
        // Curbside Pickup
        this._vColor = '', this._vMakeModel = '', this._isPreferCurbsideEnabled = false, this._isPickUpLocationSelected = false,
        // address Store
        this._isSavedAddressActive = true, this._deliveryAddress = {}, this._index = Number.NaN,
        // Scheduler Store
        this._showOrderScheduler = false, this._scheduledDate = null, this._scheduledItem = null,
        // Delivery store
        this._deliveryDistance = null;
        this._deliveryDistanceInMeter = null;
        this._deliveryFeeType = null;
        this._deliveryFee = null;
        this._tempOrderType = null;
        this._startOrder = false;
    },


    // Add delivery address
    addDeliveryAddress: function addDeliveryAddress(orderType, deliveryAddress, index) {

        this._deliveryAddress = _lodash2.default.assign({}, this._deliveryAddress, deliveryAddress);
        if (orderType == 'PickUp') {
            this._deliveryAddress = {};
        }
        this._orderType = orderType;
        this._index = index;
        // this.triggerDeliveryAddressChange();
    },


    // Delete delivery address
    deleteDeliveryAddress: function deleteDeliveryAddress(addressToDelete) {
        if (_lodash2.default.isEqual(this._deliveryAddress, addressToDelete)) {
            this._deliveryAddress = {};
            this._index = Number.NaN;
            this._orderType = "Delivery";
            // this.triggerDeliveryAddressChange();
        }
    },


    // // Reset delivery address
    // resetDeliveryAddress() {
    //     this._deliveryAddress = {};
    //     this._index           = Number.NaN;
    //     // Default OrderType is Delivery
    //     // this._orderType       = "Delivery";
    //     this._orderType       = "PickUp";
    //     // this.triggerDeliveryAddressChange();
    // },

    setDeliveryDistance: function setDeliveryDistance(deliveryDistance) {
        this._deliveryDistance = deliveryDistance;
    },
    setDeliveryDistanceInMeter: function setDeliveryDistanceInMeter(deliveryDistance) {
        this._deliveryDistanceInMeter = deliveryDistance;
    },
    setDeliveryFee: function setDeliveryFee(fee) {
        this._deliveryFee = fee;
    },
    setDeliveryFeeType: function setDeliveryFeeType(feeType) {
        this._deliveryFeeType = feeType;
    },
    getCurrentAddressIndex: function getCurrentAddressIndex() {
        return this._index;
    },
    showOrderScheduler: function showOrderScheduler(item) {
        this._scheduledItem = item;
        this._showOrderScheduler = true;

        this.triggerSchedulerChange();
    },


    // hideOrderScheduler() {
    //     this._showOrderScheduler = false;
    //     this.triggerSchedulerChange();
    // },

    getScheduledDate: function getScheduledDate() {
        return this._scheduledDate;
    },
    getScheduledItem: function getScheduledItem() {
        return this._scheduledItem;
    },

    // setTempOrderType(orderType){
    //     this._tempOrderType = orderType;
    // },
    //
    // getTempOrderType(){
    //     return this._tempOrderType;
    // },

    refreshAddressStore: function refreshAddressStore() {
        this.triggerDeliveryAddressChange();
    },
    getStartOrder: function getStartOrder() {
        return this._startOrder;
    },
    triggerDeliveryAddressChange: function triggerDeliveryAddressChange() {
        var addressObj = {
            deliveryAddress: this._deliveryAddress,
            orderType: this._orderType
        };
        this.trigger('change', addressObj);
    },
    updateScheduleScreenData: function updateScheduleScreenData(scheduleObj) {

        // Order Type
        this._orderType = scheduleObj.orderType;

        // Curbside Picker
        this._isPreferCurbsideEnabled = scheduleObj.isPreferCurbside;
        this._isPickUpLocationSelected = scheduleObj.isPickUpLocationSelected;
        this._vColor = scheduleObj.vColor;
        this._vMakeModel = scheduleObj.vMakeModel;
        this._startOrder = scheduleObj.startOrder;
        // this._scheduledDate      = scheduleObj.scheduledDate;

        // Delivery

        // this._name     = scheduleObj.name;
        // this._phoneNumber = scheduleObj.phoneNumber;
        // this._email = scheduleObj.email;

        if (scheduleObj.hasOwnProperty("isSavedAddressActive")) {
            this._isSavedAddressActive = scheduleObj.isSavedAddressActive;
        }

        // set value for delivery
        if (scheduleObj.orderType == DELIVERY) {

            // this._deliveryAddressObj =  scheduleObj.deliveryAddressObj;

            //add delivery address
            if (!Utils.isEmptyObj(scheduleObj.deliveryAddressObj)) {

                this.addDeliveryAddress(this._orderType, scheduleObj.deliveryAddressObj, scheduleObj.idx);
            }
        } else {
            // reset all the delivery details
            this.resetDeliveryDetail();
        }

        // Dine In
        this._sldata = scheduleObj.sldata;

        //Schedule
        this._scheduledDate = scheduleObj.scheduledDate;

        this.triggerSchedulerChange();
    },


    //reset schedule date
    resetScheduleDate: function resetScheduleDate() {
        this._scheduledDate = null;
        return this._scheduledDate;
    },
    getSavedAddressActive: function getSavedAddressActive() {
        return this._isSavedAddressActive;
    },
    resetDeliveryDetail: function resetDeliveryDetail() {

        // address Store
        this._deliveryAddress = {}, this._index = Number.NaN,
        // Delivery store
        this._deliveryDistance = null;
        this._deliveryDistanceInMeter = null;
        this._deliveryFeeType = null;
        this._deliveryFee = null;
    },


    //Trigger cart change
    triggerSchedulerChange: function triggerSchedulerChange() {

        var scheduleObject = {
            orderType: this._orderType,
            sldata: this._sldata,
            vColor: this._vColor,
            vMakeModel: this._vMakeModel,
            isPreferCurbside: this._isPreferCurbsideEnabled,
            isPickUpLocationSelected: this._isPickUpLocationSelected,
            deliveryAddress: this._deliveryAddress,
            deliveryDistance: this._deliveryDistance,
            deliveryDistanceInMeter: this._deliveryDistanceInMeter,
            deliveryFeeType: this._deliveryFeeType

            //update schedule screen updated states.
        };this.trigger('change', scheduleObject);
    },
    clearScheduleScreenStore: function clearScheduleScreenStore() {
        var reloadStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;


        this._orderType = 'PickUp';
        this._isSavedAddressActive = true, this._sldata = '', this._vColor = '', this._vMakeModel = '', this._isPreferCurbsideEnabled = false,

        // address Store
        this._deliveryAddress = {}, this._index = Number.NaN,
        // Scheduler Store
        this._showOrderScheduler = false, this._scheduledDate = null, this._scheduledItem = null,
        // Delivery store
        this._deliveryDistance = null;
        this._deliveryDistanceInMeter = null;
        this._deliveryFeeType = null;
        this._deliveryFee = null;

        if (reloadStore == true) {
            this.triggerSchedulerChange();
        }
    }
});
exports.default = ScheduleScreenStore;


//////////////////
// WEBPACK FOOTER
// ./src/stores/ScheduleScreenStore.jsx
// module id = 352
// module chunks = 0